import initializeApp from 'utils/initializeApp'
import { startPresenceHeartbeat, stopPresenceHeartbeat } from 'utils/presenceHeartbeat'
import jwtDecode from 'jwt-decode'
import authRequest from 'utils/authRequest'
import adminRequest from 'utils/adminRequest'
import studentRequest from 'utils/studentRequest'
import { clearLocalStorageAndCookies } from '../../utils/helpers'
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS'
export const SET_STUDENT_ID = 'SET_STUDENT_ID'
export const SET_LAST_LOCATION = 'SET_LAST_LOCATION'
export const SET_NOTIFICATION_LIST = 'SET_NOTIFICATION_LIST'
export const SET_COUNTRIES_LIST = 'SET_COUNTRIES_LIST'
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS'
export const SignInSuccess = token => {
  return {
    type: SIGN_IN_SUCCESS,
    token,
  }
}

export const setStudentId = id => {
  return {
    type: SET_STUDENT_ID,
    id,
  }
}

export const setLastLocation = data => {
  return {
    type: SET_LAST_LOCATION,
    data,
  }
}

export const setNotificationList = data => {
  return {
    type: SET_NOTIFICATION_LIST,
    data,
  }
}

export const setCountriesList = data => {
  return {
    type: SET_COUNTRIES_LIST,
    data,
  }
}
export const setCurrentUserPermissions = data => {
  return {
    type: SET_USER_PERMISSIONS,
    data,
  }
}

export const SignIn = token => async dispatch => {
  try {
    if (!token) {
      clearLocalStorageAndCookies()
    }
    if (token) {
      const decodedToken = jwtDecode(token)
      // Store token in sessionStorage and localStorage
      sessionStorage.setItem('token', token)
      localStorage.setItem('token', token)
      initializeApp(token)
      startPresenceHeartbeat()
      dispatch(SignInSuccess(token))
      dispatch(setStudentId(decodedToken?.user?.student_id))
      let studentId = decodedToken?.user?.student_id
      return studentId || ''
    }
  } catch (error) {
    console.error('Getting error while login', error)
  }
}

export const signOut = token => async (dispatch,getState) => {
  const state = getState()
  let payLoad = {}
  try {
    //
    await studentRequest.put(`students/institute/roleMetrics/${state?.auth?.studentId}/count`,payLoad)
    stopPresenceHeartbeat()
    let response = await authRequest.post(`users/signout`)
    if (response?.status >= 200 && response?.status <= 300) {
      clearLocalStorageAndCookies()
      SuccessMessage('Logged out successfully!')
    }
  } catch (error) {
    console.error('Getting error while login', error)
  }
}

export const getNotificationsList =
  ({ userId, pageLimit = 20, currentPage = 1, isAction = false, setLoading }) =>
  async (dispatch, getState) => {
    try {
      setLoading(true)
      let response = await authRequest.get(
        `/users/${userId}/notification?pageLimit=${pageLimit}&currentPage=${currentPage}&isAction=${isAction}`
      )
      dispatch(setNotificationList(response?.data?.data || {})) // need to check after API available
      setLoading(false)
      return response
    } catch (error) {
      console.error('Getting error in user notification list =>', error)
      ErrorMessage(error?.response?.data?.message)
      setLoading(false)
      return error
    }
  }

export const markNotificationReadApi =
  ({ userId, payload }) =>
  async (dispatch, getState) => {
    try {
      let response = await authRequest.put(
        `/users/${userId}/notification/markasread`,
        payload
      )
      return response
    } catch (error) {
      console.error('Getting error in marking notification as read.', error)
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

export const getListOfCountries =
  ({
    searchValue,
    pageLimit = 50,
    currentPage = 0,
    phoneCodeSearch,
    currencySearch,
  }) =>
  async (dispatch, getState) => {
    let searchKey = searchValue ? `&search=${searchValue}` : ''

    let phoneCode = phoneCodeSearch ? `&phone_code=${phoneCodeSearch}` : ''
    let currency = currencySearch ? `&currency=${currencySearch}` : ''
    try {
      let response = await authRequest.get(
        `/search/countries?currentPage=${currentPage}&pageLimit=${pageLimit}${searchKey}${phoneCode}${currency}`
      )
      dispatch(setCountriesList(response?.data?.data?.result || []))
      return response
    } catch (error) {
      console.error('Error in getting list of countries.', error)
      ErrorMessage(error?.response)
      return error?.response
    }
  }

export const getUserPermissions = roleId => async (dispatch, getState) => {
  try {
    let resp = await adminRequest.get(
      `roleEvents/${roleId}?journey=STUDENT&roleName=ADMIN`
    )
    dispatch(setCurrentUserPermissions(resp?.data?.data))
  } catch (error) {
    console.error('Getting error in user data', error)
  }
}
